.containerOuter {
    padding: 1rem;
    background-color: var(--static-background-strong);
    border-radius: 8px;
    border: 1px solid var(--static-divider-standard);
    margin-top: 1.5rem;
}